import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import Layout from './layout.js';
import InfoGraphic from '../../svg/info-graphic.js';
import Footer from './footer.js';
import {Helmet} from 'react-helmet';

class Info extends React.Component {
  render() {
    let info = DataStore.getPageBySlug('info');

    return (
      <div>
        <Helmet>
          <title>Mold Architects - {info.title.rendered}</title>
          <meta name="description" content={info.yoast.metadesc} />
          <meta name="keywords" content={info.yoast.metakeywords} />

          <meta property="og:title" content={info.yoast['opengraph-title'] || 'Mold Architects - Info'} />
          <meta name="og:description" content={info.yoast['opengraph-description'] || info.yoast.metadesc} />
          <meta property="og:image" content={info.yoast['opengraph-image']} />

          <meta name="twitter:title" content={info.yoast['twitter-title'] || 'Mold Architects - Info'} />
          <meta name="twitter:description" content={info.yoast['twitter-description'] || info.yoast.metadesc} />
          <meta name="twitter:image" content={info.yoast['twitter-image'] || info.yoast['opengraph-image']} />
        </Helmet>
        <Layout>
          <section className="info-section">
            <div className="cnt two-thirds">
              {info.acf.peoples.map((person, i)=>{
                return <div className="person" key={i}>
                  <div className="thumb-cnt">
                  {person.photo !== null & person.photo !== undefined && person.photo ?
                    <img src={person.photo.url} alt="Mold Architect" />:null }
                    <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                    <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                    <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                  </div>
                  <InfoGraphic />
                  <div className="bio">
                    <div className="cnt">
                      <div className="bio-text" dangerouslySetInnerHTML={{__html:person.bio}} />
                    </div>

                    <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                    <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                    <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                  </div>
                </div>
              })}

            </div>
            <div className="cnt one-third">
                <div className="contact-cnt">
                  <div className="cnt">
                    <div className="contact">
                      <h2>Contact</h2>
                      <div dangerouslySetInnerHTML={{__html:info.acf.contact}} />
                    </div>
                    {info.acf.jobs !== null && info.acf.jobs.length > 0 ?
                      <div className="jobs">
                        <h2>Jobs</h2>
                        <div dangerouslySetInnerHTML={{__html:info.acf.jobs}} />
                      </div>:null
                    }

                    {info.acf.extra_field !== null && info.acf.extra_field.length > 0 ?
                      <div className="extra-field">
                        {info.acf.extra_field_title.length > 0 ? <h2>{info.acf.extra_field_title}</h2>: null}
                        <div dangerouslySetInnerHTML={{__html:info.acf.extra_field}} />
                      </div>:null
                    }
                  </div>
                  <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="ipad-crosses">
                    <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                    <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                  </div>
                </div>
            </div>
          </section>
        </Layout>
        <Footer footerClass="contact" />
      </div>
    );
  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/scripts/components/info.js